module.exports = __webpack_public_path__ + "img/zm.fb1b73f9.gif";